var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHalfActiveStar = function SvgHalfActiveStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25.2 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "half-active-star_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4308",
    transform: "translate(654.204 1097)",
    fill: "#fff",
    d: "M0 0h12.596v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12921"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6 0 8.719 7.92 0 9.168l6.324 6.144L4.839 24l7.761-4.08L20.361 24l-1.485-8.688L25.2 9.168 16.48 7.92Z",
    fill: "#cbd0d6"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 157",
    clipPath: "url(#half-active-star_svg__a)",
    transform: "translate(-654.201 -1097)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "favorite",
    d: "m666.804 1097-3.881 7.92-8.719 1.248 6.324 6.144-1.485 8.688 7.761-4.08 7.761 4.08-1.485-8.688 6.324-6.144-8.72-1.248Z",
    fill: "#fcc153"
  })))));
};
export default SvgHalfActiveStar;